"use client";
import React from "react";
import * as NavigationMenu from "@radix-ui/react-navigation-menu";
import { letters } from "./data";
import { scrollToSection } from "@/utils";

export default function GlossarySubnav({
  enabledLetters,
}: {
  enabledLetters: string[];
}) {
  const fullAlphabet = "abcdefghijklmnopqrstuvwxyz".split("");
  const letters = fullAlphabet.map((letter) => {
    return {
      id: letter,
      disabled: !enabledLetters.includes(letter),
    };
  });

  return (
    <div className="bg-white w-full shadow-elevation-300 z-[49] rounded-b-lg">
      <div className="px-2 md:px-4 flex items-center justify-start gap-4 h-full overflow-x-auto overflow-y-hidden">
        <div className="overflow-x-auto overflow-y-hidden">
          <NavigationMenu.Root
            aria-label="Main"
            data-orientation="horizontal"
            dir="ltr"
          >
            <NavigationMenu.List
              data-orientation="horizontal"
              className="flex flex-row items-center h-[3.75rem] min-w-[18.75rem]"
              dir="ltr"
            >
              {letters.map((letter, _) => (
                <NavigationMenu.Item
                  key={`letter-${letter.id}`}
                  asChild
                  className="h-full flex items-center"
                >
                  <button
                    data-disabled={letter.disabled}
                    onClick={() => scrollToSection(letter.id)}
                    className={`w-7 px-2 h-full flex items-center justify-center text-headline-bold uppercase ${
                      letter.disabled
                        ? "opacity-30 cursor-not-allowed"
                        : "cursor-pointer hover:text-primary-500"
                    }`}
                  >
                    {letter.id}
                  </button>
                </NavigationMenu.Item>
              ))}
            </NavigationMenu.List>
          </NavigationMenu.Root>
        </div>
      </div>
    </div>
  );
}
